import { Component, Inject, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatList } from '@angular/material/list';
import { ContactsData } from 'src/app/contacts/contacts.data';
import { ServicesData } from 'src/app/services/services.data';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';




@Component({
  templateUrl: './contact-voice-name-dlg.tmpl.html'
})

export class ContactVoiceNameDlg implements OnInit {
  public formData: FormGroup;
  public isRecording = false;
  public audioUrl: SafeUrl;
  public fileName: string;
  public recordingTime = "00:00";

  private mediaRecorder: MediaRecorder;
  private audioChunks: any[] = [];
  private recordingInterval: any;
  private startTime: number;

  constructor(
    public matDialogRef: MatDialogRef<ContactVoiceNameDlg>,
    @Inject(MAT_DIALOG_DATA) public data: any, //{contactID , contactName}
    private formBuilder: FormBuilder,
    public servicesData: ServicesData,
    public contactsData: ContactsData,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef
  ) { }


  ngOnInit(): void {
    this.loadData();
    this.initForm();
  }

  loadData() {
      this.contactsData.getVoiceName(this.data.contactID).subscribe((blob: any) => {
          if (blob && blob.size > 0) {
              this.audioUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
              this.fileName = "קובץ קיים";
          }
      });
  }


  private initForm(): void {
    this.formData = this.formBuilder.group({
      createBy: [], createDate: [], changeBy: [], changeDate: [],
      contactID: [this.data.contactID, Validators.required],
   //   contactName: [this.data.contactName, Validators.required],
      fileBytes: [, Validators.required]
    });
  }


  onNoClick(): void {
    this.stopRecording();
    this.matDialogRef.close();
  }

  // public onSubmit(): void {

  //         this.contactsData.saveVoiceName(this.formData.value).subscribe((result: any) => {
  //             this.matDialogRef.close(result);
  //         });
  // }

  public isValid(): boolean {
      return (this.formData && this.formData.valid);
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.processFile(file);
    }
  }

  processFile(file: File) {
      const url = URL.createObjectURL(file);
      const audio = new Audio();
      audio.src = url;

      audio.onloadedmetadata = () => {
          if (audio.duration > 4) {
              alert("קובץ השמע ארוך מדי. האורך המקסימלי הוא 4 שניות.");
              URL.revokeObjectURL(url);
              this.fileName = null;
              this.formData.patchValue({ fileBytes: null });
              return;
          }

          const reader = new FileReader();
          reader.onload = (e: any) => {
              const binaryString = window.atob(e.target.result.split(',')[1]);
              const len = binaryString.length;
              const bytes = new Uint8Array(len);
              for (let i = 0; i < len; i++) {
                  bytes[i] = binaryString.charCodeAt(i);
              }
              this.formData.patchValue({ fileBytes: Array.from(bytes) });

              this.audioUrl = this.sanitizer.bypassSecurityTrustUrl(url);
          };
          reader.readAsDataURL(file);
      };
  }

  startRecording() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
            this.mediaRecorder = new MediaRecorder(stream);
            this.mediaRecorder.start();
            this.isRecording = true;
            this.audioChunks = [];
            this.startTime = Date.now();
            this.updateRecordingTime();
            this.recordingInterval = setInterval(() => {
                this.updateRecordingTime();
                if ((Date.now() - this.startTime) >= 4000) {
                     this.stopRecording();
                }
            }, 100);

            this.mediaRecorder.addEventListener("dataavailable", event => {
                this.audioChunks.push(event.data);
            });

            this.mediaRecorder.addEventListener("stop", () => {
                const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
                const file = new File([audioBlob], "recording.wav", { type: "audio/wav" });
                this.fileName = "recording.wav";
                this.processFile(file);

                stream.getTracks().forEach(track => track.stop());
            });
        })
        .catch(err => console.error("Error accessing microphone:", err));
    } else {
        alert("הדפדפן שלך לא תומך בהקלטה.");
    }
  }

  stopRecording() {
      if (this.isRecording && this.mediaRecorder) {
          this.mediaRecorder.stop();
          this.isRecording = false;
          clearInterval(this.recordingInterval);
      }
  }

  updateRecordingTime() {
      const duration = Date.now() - this.startTime;
      const seconds = Math.floor((duration / 1000) % 60);
      const minutes = Math.floor((duration / (1000 * 60)) % 60);
      this.recordingTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      this.cd.detectChanges();
  }
}

